import simpleParallax from 'simple-parallax-js'

const parallaxScroll = () => {
  const visuals = document.querySelectorAll('.js-parallax-visual')

  // eslint-disable-next-line
  new simpleParallax(visuals, {
    delay: 0,
    scale: 1.2,
    customWrapper: '.js-parallax-wrapper'
  })
}

export default parallaxScroll
